module.exports = __webpack_public_path__ + "static/book-6869ec1a7d165d10fc685c4f79f41dad.png";